<template>
  <div class="lazy-container">
    <sub-menu id="section-submenu" nohide="true"></sub-menu>
    <section class="mt3" v-if="team">
      <div class="col-12 center mb3">
        <h2 class="caps">Forensic Architecture</h2>
      </div>
      <div class="col-12 md-col-10 lg-col-10 mx-auto flex flex-wrap">
        <person-preview
          v-for="person in team.current"
          :content="person"
          :key="person.id"
          :showDetails="true"
          classes="md-col-4"></person-preview>
      </div>
    </section>

    <section v-if="team">
      <div class="col-12 center mb3">
        <h2 class="caps">Research Fellows</h2>
      </div>
      <div class="col-12 md-col-10 lg-col-10 mx-auto flex flex-wrap">
        <person-preview
          v-for="person in team.extended"
          :content="person"
          :key="person.id"
          :showDetails="true"
          classes="md-col-4"></person-preview>
      </div>
    </section>

    <section v-if="team">
      <div class="col-12 center mb3">
        <h2 class="caps">Past</h2>
      </div>
      <div class="col-12 md-col-10 lg-col-10 mx-auto flex flex-wrap">
        <person-preview
          v-for="person in team.past"
          :content="person"
          :key="person.id"
          :showDetails="false"
          classes="md-col-3"></person-preview>
      </div>
    </section>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu'
import PersonPreview from '@/components/PersonPreview'
import { mapState, mapActions } from 'vuex'

export default {

  name: 'Team',

  data () {
    return {
      lazyContainer: this.lazyLoad({
        elements_selector: ".lazy-container img"
      })
    }
  },

  mounted () {
    this.$nextTick(function () {
      this.lazyContainer.update()
    })
  },

  metaInfo () {
    let title = 'Team'
    return {
      title: title,
      meta: [
        { name: 'og:title', content: `Forensic Architecture → ${title}` },
        { name: 'twitter:title', content: `Forensic Architecture → ${title}` },
        { name: 'og:image', content: '/fa-share-lg.png' },
        { name: 'twitter:image', content: '/fa-share-lg.png' },
        { name: 'og:url', content: `${window.location.origin}/${this.$route.fullPath}` },
        { name: 'og:type', content: 'website' },
        { name: 'og:description', content: this.siteDescription() },
        { name: 'twitter:description', content: this.siteDescription() }
      ]
    }
  },

  components: {
    PersonPreview,
    SubMenu
  },

  computed: {
    ...mapState([
      'team'
    ])
  },

  methods: {
    ...mapActions([
      'getTeam'
    ])
  },

  created: function () {
    this.getTeam()
  },

  watch: {
    'team' () {
      this.$nextTick(function () {
        this.lazyContainer.update()
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
